import { connect } from 'react-redux';
import { State } from 'store/types';
import SearchAutoSuggestions from 'layouts/SearchAutoSuggestions';


const mapStateToProps = (state: State) => {
  const { appReducer } = state;
  return {
    pageType: appReducer.pageType,
  };
};

export default connect(mapStateToProps)(SearchAutoSuggestions);
